var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (typeof _vm.errors === 'object')?_c('div',{staticClass:"md-error"},_vm._l((_vm.errors),function(error){return _c('div',{key:error},[_vm._v(_vm._s(error))])}),0):_c('span',{staticClass:"md-error"},[_vm._v(_vm._s(_vm.errors))])}
var staticRenderFns = []

export { render, staticRenderFns }